// extracted by mini-css-extract-plugin
export var inpSearchExpandableWrapper = "InputSearchExpandable_inpSearchExpandableWrapper__HWApQ";
export var inpSearchExpandable = "InputSearchExpandable_inpSearchExpandable__69dT8";
export var rotate = "InputSearchExpandable_rotate__frcVS";
export var dotty = "InputSearchExpandable_dotty__BHheb";